import script from "./RebateStatistics.vue?vue&type=script&setup=true&lang=ts"
export * from "./RebateStatistics.vue?vue&type=script&setup=true&lang=ts"

import "./RebateStatistics.vue?vue&type=style&index=0&id=1fd69da5&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd69da5"]])

export default __exports__